import Immutable from "immutable";

import types from "./types";

import { RESET_GIVING_FORM } from "../types";

export const initialState = Immutable.fromJS({
  billingType: "",
  paymentType: "",
  paymentInterval: "",
  showAverageAmount: true,
  isStripeSepaDebit: false,
});

export default (state = initialState, action) => {
  const { type } = action;

  switch (type) {
    case types.SET_BILLING_TYPE:
      return state.withMutations((state) => {
        state
          .set("billingType", action.billingType)
          .set("paymentType", "")
          .set("paymentInterval", null);
      });

    case types.SET_PAYMENT_TYPE:
      return state.withMutations((state) => {
        state.set("paymentType", action.paymentType).set("paymentInterval", null);
      });

    case types.SET_PAYMENT_INTERVAL:
      return state.set("paymentInterval", action.paymentInterval);

    case RESET_GIVING_FORM:
      return initialState;

    case types.TOGGLE_AVERAGE_AMOUNT:
      return state.set("showAverageAmount", action.bool);

    case types.IS_STRIPE_SEPA_DEBIT:
      return state.set("isStripeSepaDebit", action.isStripeSepaDebit);

    default:
      return state;
  }
};
